import './src/styles/global.less';
import './src/fonts/fonts.less';

import React from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';

import {AuthProvider} from '_contexts/auth';

export const wrapRootElement = ({element}) => <AuthProvider>{element}</AuthProvider>;

export const onRouteUpdate = () => {
  window?.analytics && window.analytics.page();
};
